import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class PlatillosService {

  private dbPath = '/platillos';

  objetoRef: AngularFirestoreCollection<any> = null;

  constructor(private db:AngularFirestore) {
    this.objetoRef = db.collection(this.dbPath);
  }

  getAll(): AngularFirestoreCollection<any>{
      /* return this.db.collection(this.dbPath, ref => ref.orderBy('category.orden')); */
      /* return this.db.collection(this.dbPath, ref => ref); */
      return this.db.collection(this.dbPath, ref => ref.orderBy('category.orden','asc').orderBy('title','asc'));
  }

  nuevo(obj):void{
    let temp = { ...obj };
    delete temp.uid;
    this.objetoRef.add(temp);
  }

  edit(value, uid){
    let temp = { ...value };
    delete temp.uid;
    return this.objetoRef.doc(uid).update(temp);
  }

  delete(uid:string){
    return this.objetoRef.doc(uid).delete();
  }
}
